import { render, staticRenderFns } from "./EditorAnswer.vue?vue&type=template&id=1b2b3497&scoped=true&"
import script from "./EditorAnswer.vue?vue&type=script&lang=ts&"
export * from "./EditorAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./EditorAnswer.vue?vue&type=style&index=0&id=1b2b3497&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2b3497",
  null
  
)

export default component.exports